<simple-notifications [options]="notificationsOptions" [@.disabled]="!enableAnimations"></simple-notifications>